import { RootState } from '../../Store';

import { useSelector } from 'react-redux';
import { ModificationLoanForm } from '../../Interface/Response/Interest/ModificationLoanForm';

const useGetModificationLoanForms = (): ModificationLoanForm[] => {
    return useSelector<RootState, ModificationLoanForm[]>(state => state.loanForm.loanForms);
};

export default useGetModificationLoanForms;
